import { render } from "./UpsideDownText.vue?vue&type=template&id=59598c4b"
import script from "./UpsideDownText.vue?vue&type=script&lang=js"
export * from "./UpsideDownText.vue?vue&type=script&lang=js"

import "./UpsideDownText.vue?vue&type=style&index=0&id=59598c4b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__